import { Routes, Route } from 'react-router-dom';
import Nav from './components/nav/nav.component';
import Home from './pages/home/home.component';
import Backlinks from './pages/backlinks/backlinks.component';
import Orders from './pages/orders/orders.component';
import Settings from './pages/settings/settings.component';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
    <>
      <Nav />
      <div style={{
        padding: '1rem',
      }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/backlinks" element={<Backlinks />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/:id" element={<Orders />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </div>
    </>
  );
}

export default App;
